import React from "react";
import Typography from "apollo-react/components/Typography";
import AlertTriangle from "apollo-react-icons/AlertTriangle";
import ThumbsUp from "apollo-react-icons/ThumbsUpFilled";
import FileDocuments from "apollo-react-icons/FileDocuments";
import Spinner from "apollo-react-icons/Refresh";
import styles from "./SubFormTab.module.css";

const SubFormTab = React.memo(
  ({ form, isActive, onClick, isLoading, prevComments, errors }) => {
    // for custom forms, use the hasComments property directly
    // for regular subforms, check prevComments for subForm_id
    const hasComments = form.hasComments !== undefined
      ? form.hasComments
      : prevComments?.find((comment) => comment.subForm_id === form.id);

    const tabClass = isActive
      ? styles.activeTab
      : form.approved
        ? styles.approvedTab
        : hasComments
          ? styles.commentTab
          : "";

    const renderIcon = () => {
      if (isLoading) {
        return (
          <Spinner className={`${styles.thumbsUpIcon} ${styles.loadingIcon}`} />
        );
      }
      if (form.approved) {
        return <ThumbsUp className={styles.thumbsUpIcon} />;
      }
      if (hasComments) {
        return <FileDocuments className={styles.thumbsUpIcon} />;
      }

      if (errors?.subforms?.[form.id]?.hasErrors) {
        return <AlertTriangle className={styles.thumbsUpIcon} />;
      }

      if (errors?.productDetails?.hasErrors && form.id === 'custom_product_details') {
        return <AlertTriangle className={styles.thumbsUpIcon} />;
      }

      if (errors?.manufacturersSite?.hasErrors && form.id === 'custom_manufacturers_site') {
        return <AlertTriangle className={styles.thumbsUpIcon} />;
      }
    };

    return (
      <div
        onClick={() => onClick(form.id)}
        className={`${styles.verticalTabItemContainer} ${tabClass}`}
      >
        <Typography className={styles.verticalTabItemText}>
          {form.name}
        </Typography>
        {renderIcon()}
      </div>
    );
  }
);

export default SubFormTab;
